import classNames from 'classnames';
import React from 'react';

import { bsClass, getClassSet, splitBsProps } from './utils/bootstrapUtils';

class MediaListItem extends React.Component {
  render() {
    const { className, ...props } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);

    const classes = getClassSet(bsProps);

    return (
      <li
        {...elementProps}
        className={classNames(className, classes)}
      />
    );
  }
}

export default bsClass('media', MediaListItem);



// WEBPACK FOOTER //
// ./src/MediaListItem.js